import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row'
import TCol from 'components/shared/table/table-column'
import ColStatus from '../col-status'

const ConfirmedList = ({ headers, list, fetchConfirmed }) => {
  useEffect(() => {
    fetchConfirmed()
  }, [])

  return (
    <div className="client-requests-list">
      <div className="mt-5">
        <div className="overflow-auto">
          <Table classes="w-full border-collapse">
            <THead classes="text-xs bg-lightgray font-semibold">
              {headers.map((header, key) => (
                <TCol classes="p-3" key={key} align={header.align || 'left'}>
                  {header.name}
                </TCol>
              ))}
            </THead>
            <TBody>
              {list.map(item => (
                <TRow classes="border-t text-sm hover:bg-gray-100" key={item.id}>
                  <TCol classes="p-3">{item.createDate}</TCol>
                  <TCol classes="p-3">{item.requestDate}</TCol>
                  <TCol classes="p-3 text-primary-orange">
                    <a href={item.spaceLink}>{item.space}</a>
                  </TCol>
                  <TCol classes="p-3">{item.address}</TCol>
                  <TCol classes="p-3">{item.amount}</TCol>
                  <ColStatus classes="p-3 font-semibold text-xs" status={item.status} />
                  <TCol classes="p-3" align="right">
                    <ul className="flex font-semibold items-center flex-row justify-end text-center text-primary-orange">
                      <li className="mx-1">
                        <Link to={`/client/messages/${item.conversation_id}/conversation`} target="_blank">Message</Link>
                      </li>
                    </ul>
                  </TCol>
                </TRow>
              ))}
            </TBody>
          </Table>
        </div>
      </div>
    </div>
  )
}

ConfirmedList.propTypes = {
  headers: PropTypes.array.isRequired,
  fetchConfirmed: PropTypes.func.isRequired,
  list: PropTypes.array,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.client.confirmed.headers,
  list: bookings.client.confirmed.list,
})

const mapDispatchToProps = {
  fetchConfirmed: bookingActions.fetchClientConfirmed,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmedList)
